import type { CSSProperties } from "react";
import { Toaster as SonnerToaster } from "sonner";
import type { ToasterProps } from "sonner";
import { DEFAULT_TOAST_DURATION, VISIBLE_TOASTS_CAP } from "./config";

// Design width is 400px; cap to the viewport (minus the 16px gutters) so it never overflows
// the 320px mobile floor. Sonner sizes each toast li to this `--width`; our card fills it.
const TOAST_WIDTH = {
  "--width": "min(400px, calc(100vw - 2rem))",
} as CSSProperties;

/**
 * The app toast surface: Sonner's Toaster with our defaults baked in (position, duration,
 * visible-toasts cap). Mount ONCE in the app shell — this module does not mount it. Props passed
 * here override the defaults.
 *
 * Position is fixed bottom-right: the platform is LTR-only, so the corner no longer depends on
 * `<html dir>` and Sonner's `dir` prop is left at its default.
 */
export function Toaster(props: ToasterProps) {
  return (
    <SonnerToaster
      position="bottom-right"
      duration={DEFAULT_TOAST_DURATION}
      visibleToasts={VISIBLE_TOASTS_CAP}
      style={TOAST_WIDTH}
      {...props}
    />
  );
}
